export interface IWebsiteStaticTexts {
    [key: string]: IWebsiteStaticTextsGroup[];
}

export interface IWebsiteStaticTextsGroup {
    default: string;
    key: string;
    value: string;
}
